import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CtaLink } from "@/components/landing/CtaLink";

export function FinalCTASection() {
  return (
    <section className="py-[80px] md:py-[100px] lg:py-[120px]">
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={false}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium text-foreground/95 tracking-tight leading-[1.1] mb-8">
            Your next proposal starts here.
          </h2>
          
          <p className="text-base md:text-lg font-normal text-muted-foreground max-w-xl mx-auto mb-12 leading-[1.75]">
            See how Sorvaine's AI takes you from tender to first draft in <span className="text-white font-medium">minutes</span>. Most teams are live within 24 hours.
          </p>
          
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4 mb-10 max-w-xs sm:max-w-none mx-auto">
            <CtaLink to="/signup" cta="get_started" location="final_cta">
              <Button className="w-full sm:w-auto rounded-full bg-primary hover:bg-primary/90 px-8 py-6 text-primary-foreground text-base">
                Get started
                <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </CtaLink>
            <CtaLink to="/book-demo" cta="book_demo" location="final_cta">
              <Button variant="ghost" className="w-full sm:w-auto rounded-full px-8 py-6 text-white/70 hover:text-white hover:bg-white/5 text-base">
                Or book a demo
              </Button>
            </CtaLink>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
